import { memo } from 'react'

import { CompareItemsTableDataCell as TCompareItemsTableDataCell } from '../../types'

import style from './DataCell.module.scss'

export default memo(
  CompareItemsTableDataCell,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableDataCell({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableDataCell
}) {
  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableDataCell} ${
        cell.bold ? style['CompareItemsTableDataCell--bold'] : ''
      } ${0 < cell.text.length ? '' : style['CompareItemsTableDataCell--empty']}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
    >
      <span dangerouslySetInnerHTML={{ __html: cell.text }} />
      {cell.sigtest?.length ? (
        <span className={style.CompareItemsTableDataCell__sigtest}>
          {cell.sigtest.map((sigtest, index) => (
            <span
              key={`${sigtest.letter}-${index}`}
              className={style.CompareItemsTableDataCell__sigtest__letter}
              title={sigtest.title}
            >
              {sigtest.letter}
            </span>
          ))}
        </span>
      ) : null}
    </div>
  )
}
